import React from 'react';
import {SlotsPlaceholder} from '@wix/widget-plugins-ooi';
import {ReviewsSlotIds} from '../../constants';

export class ReviewsSlot extends React.Component {
  public render() {
    return <SlotsPlaceholder slotId={ReviewsSlotIds.ProductPageBottomSlot} />;
  }
}
